import Vue from 'vue'
import axios from 'axios'

import {
  ACCOUNT_USER_ALL,
  ACCOUNT_USER_CREATE,
  ACCOUNT_USER_READ,
  ACCOUNT_USER_UPDATE,
  ACCOUNT_USER_DELETE
} from '../actions'

import {
  ACCOUNT_USER_ADDED,
  ACCOUNT_USER_LOADING,
  ACCOUNT_USER_SUCCESS,
  ACCOUNT_USER_ERROR,
  ACCOUNT_USER_SET,
  ACCOUNT_USERS_SET,
  ACCOUNT_USER_CURRENT_PAGE_SET,
  ACCOUNT_USER_PER_PAGE_SET,
  ACCOUNT_USER_TOTAL_PAGES_SET,
  ACCOUNT_USER_SEARCH_VALUE_SET
} from '../mutations'

export default {
  state: {
    status: '',
    accountUsers: [],
    accountUser: {},
    perPage: 15,
    currentPage: 1,
    totalPages: 0,
    searchValue: ''
  },

  mutations: {
    [ACCOUNT_USER_ADDED]: (state, tag) => {
      state.accountUsers.unshift(tag)
    },
    [ACCOUNT_USER_LOADING]: (state) => {
      state.status = 'loading'
    },
    [ACCOUNT_USER_SUCCESS]: (state) => {
      state.status = 'success'
    },
    [ACCOUNT_USER_ERROR]: (state) => {
      state.status = 'error'
    },
    [ACCOUNT_USER_SET]: (state, resp) => {
      Vue.set(state, 'accountUser', resp)
    },
    [ACCOUNT_USERS_SET]: (state, resp) => {
      Vue.set(state, 'accountUsers', resp)
    },
    [ACCOUNT_USER_PER_PAGE_SET]: (state, value) => {
      state.perPage = value
    },
    [ACCOUNT_USER_CURRENT_PAGE_SET]: (state, value) => {
      state.currentPage = value
    },
    [ACCOUNT_USER_TOTAL_PAGES_SET]: (state, value) => {
      state.totalPages = value
    },
    [ACCOUNT_USER_SEARCH_VALUE_SET]: (state, value) => {
      state.searchValue = value
    }
  },

  actions: {
    [ACCOUNT_USER_ALL]: ({
      commit,
      state,
      getters
    }) => {
      commit(ACCOUNT_USER_LOADING)

      let accountId = getters.getActiveAccountId
      if (!accountId) {
        console.log('no account!')
        commit(ACCOUNT_USER_ERROR)
        return
      }

      let params = {
        page: state.currentPage,
        per_page: state.perPage
      }

      if (state.searchValue && state.searchValue.length) {
        params.search = state.searchValue
      }

      axios({
        url: 'accounts/' + accountId + '/users'
      })
        .then(resp => {
          commit(ACCOUNT_USER_SUCCESS)
          commit(ACCOUNT_USERS_SET, resp.data.data)
          commit(ACCOUNT_USER_TOTAL_PAGES_SET, resp.data.meta.last_page)
        })
        .catch(resp => {
          commit(ACCOUNT_USER_ERROR)
        })
    },

    [ACCOUNT_USER_READ]: ({
      commit
    }, id) => {
      commit(ACCOUNT_USER_LOADING)
      commit(ACCOUNT_USER_SET, {})
      axios({
        url: 'users/' + id
      })
        .then(resp => {
          commit(ACCOUNT_USER_SUCCESS)
          commit(ACCOUNT_USER_SET, resp.data.data)
        })
        .catch(resp => {
          commit(ACCOUNT_USER_ERROR)
        })
    },

    [ACCOUNT_USER_CREATE]: ({
      commit,
      dispatch,
      getters
    }, data) => {
      return new Promise((resolve, reject) => {
        commit(ACCOUNT_USER_LOADING)
        commit(ACCOUNT_USER_SET, {})

        let accountId = getters.getActiveAccountId

        data.role_id = data.role.id

        axios({
          method: 'post',
          url: 'accounts/' + accountId + '/users',
          data: data
        })
          .then(resp => {
            commit(ACCOUNT_USER_SUCCESS)
            commit(ACCOUNT_USER_ADDED, resp.data.data)
            commit(ACCOUNT_USER_SET, resp.data.data)
            dispatch(ACCOUNT_USER_ALL)
            resolve(resp.data.data)
          })
          .catch(err => {
            commit(ACCOUNT_USER_ERROR)
            reject(err)
          })
      })
    },

    [ACCOUNT_USER_UPDATE]: ({
      commit,
      dispatch
    }, {
      id,
      data
    }) => {
      commit(ACCOUNT_USER_LOADING)
      commit(ACCOUNT_USER_SET, {})
      axios({
        method: 'put',
        url: 'users/' + id,
        data: data.newUserData
      })
        .then(resp => {
          commit(ACCOUNT_USER_SUCCESS)
          commit(ACCOUNT_USER_SET, resp.data.data)
          dispatch(ACCOUNT_USER_ALL)
        })
        .catch(resp => {
          commit(ACCOUNT_USER_ERROR)
        })
    },

    [ACCOUNT_USER_DELETE]: ({
      commit,
      dispatch
    }, id) => {
      commit(ACCOUNT_USER_LOADING)

      axios({
        method: 'delete',
        url: 'users/' + id
      })
        .then(resp => {
          commit(ACCOUNT_USER_SET, {})
          dispatch(ACCOUNT_USER_ALL)
        })
        .catch(resp => {
          commit(ACCOUNT_USER_ERROR)
        })
    }
  }
}
